/* =========================================================================
   My Prolearning — Blog index + Article
   Scroll reveal, back-to-top, header shadow; on articles: reading progress,
   auto Table of Contents with scrollspy, smooth anchors, share/copy + toast.
   ========================================================================= */
(function () {
  "use strict";
  var root = document.querySelector(".mpl-blog");
  if (!root) return;
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- header shadow ---------- */
  var hdr = document.querySelector("header.site, .mpl-header");
  if (hdr) window.addEventListener("scroll", function () {
    hdr.classList.toggle("scrolled", (window.scrollY || 0) > 10);
  }, { passive: true });

  /* ---------- back to top ---------- */
  var totop = root.querySelector(".bx-totop");
  if (totop) totop.addEventListener("click", function () {
    window.scrollTo({ top: 0, behavior: reduce ? "auto" : "smooth" });
  });

  /* ---------- reveal ---------- */
  var els = root.querySelectorAll(".bx-reveal");
  if (reduce || !("IntersectionObserver" in window)) {
    [].forEach.call(els, function (e) { e.classList.add("in"); });
  } else {
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (!en.isIntersecting) return;
        var sibs = [].slice.call(en.target.parentElement.children)
          .filter(function (c) { return c.classList.contains("bx-reveal"); });
        en.target.style.transitionDelay = (Math.max(0, sibs.indexOf(en.target)) * 60) + "ms";
        en.target.classList.add("in");
        io.unobserve(en.target);
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -7% 0px" });
    [].forEach.call(els, function (e) { io.observe(e); });
  }

  /* ---------- back-to-top visibility ---------- */
  function topVis() { if (totop) totop.classList.toggle("show", (window.scrollY || 0) > 700); }
  window.addEventListener("scroll", topVis, { passive: true }); topVis();

  /* ---------- share / copy link + toast ---------- */
  var toast = root.querySelector(".bx-toast");
  function showToast() {
    if (!toast) return;
    toast.classList.add("show");
    clearTimeout(showToast._t);
    showToast._t = setTimeout(function () { toast.classList.remove("show"); }, 2000);
  }
  [].forEach.call(root.querySelectorAll("[data-share-copy]"), function (btn) {
    btn.addEventListener("click", function () {
      var url = location.href;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(showToast, showToast);
      } else {
        var t = document.createElement("textarea"); t.value = url; document.body.appendChild(t);
        t.select(); try { document.execCommand("copy"); } catch (e) {} document.body.removeChild(t); showToast();
      }
    });
  });

  /* ===================== INDEX-ONLY ===================== */
  if (!root.hasAttribute("data-article")) {
    /* animated article count */
    var ups = [].slice.call(root.querySelectorAll("[data-countup]"));
    if (reduce || !("IntersectionObserver" in window)) {
      ups.forEach(function (el) { el.textContent = el.getAttribute("data-countup"); });
    } else {
      var cio = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) {
          if (!en.isIntersecting) return;
          var el = en.target, to = parseInt(el.getAttribute("data-countup"), 10) || 0, st = performance.now();
          (function tk(now) { var p = Math.min(1, (now - st) / 900), e = 1 - Math.pow(1 - p, 3); el.textContent = Math.round(to * e); if (p < 1) requestAnimationFrame(tk); })(st);
          cio.unobserve(el);
        });
      }, { threshold: 0.6 });
      ups.forEach(function (el) { cio.observe(el); });
    }
    /* scroll progress bar */
    var ibar = root.querySelector(".bx-progress");
    if (ibar) {
      var ip = function () { var h = document.documentElement.scrollHeight - window.innerHeight; ibar.style.width = (h > 0 ? ((window.scrollY || 0) / h * 100) : 0) + "%"; };
      window.addEventListener("scroll", ip, { passive: true }); ip();
    }
    /* live filter of the article grid */
    var si = document.getElementById("bxSearch");
    if (si) {
      var nores = document.getElementById("bxNores");
      var cards = [].slice.call(root.querySelectorAll(".bx-grid .bx-card"));
      si.addEventListener("input", function () {
        var q = si.value.trim().toLowerCase(), shown = 0;
        cards.forEach(function (c) {
          var hit = !q || (c.getAttribute("data-search") || "").indexOf(q) !== -1;
          c.style.display = hit ? "" : "none"; if (hit) shown++;
        });
        if (nores) nores.classList.toggle("show", q.length > 0 && shown === 0);
      });
    }
  }

  /* ===================== ARTICLE-ONLY ===================== */
  var content = document.getElementById("artxContent");
  if (!content) return;

  /* (reading progress) */
  var pbar = root.querySelector(".artx-progress");
  function progress() {
    if (!pbar) return;
    var rect = content.getBoundingClientRect();
    var total = rect.height - window.innerHeight;
    var passed = -rect.top;
    var p = total > 0 ? Math.min(1, Math.max(0, passed / total)) : (rect.top < 0 ? 1 : 0);
    pbar.style.width = (p * 100) + "%";
  }
  window.addEventListener("scroll", progress, { passive: true });
  window.addEventListener("resize", progress); progress();

  /* (auto Table of Contents + scrollspy) */
  var tocWrap = document.getElementById("artxToc");
  var heads = [].slice.call(content.querySelectorAll("h2, h3"));
  function slug(s) {
    return (s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "")
      .replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 60) || "section";
  }
  if (tocWrap && heads.length >= 2) {
    var ul = tocWrap.querySelector("ul");
    var used = {};
    heads.forEach(function (h) {
      if (!h.id) { var id = slug(h.textContent); while (used[id]) { id += "-x"; } used[id] = 1; h.id = id; }
      var li = document.createElement("li");
      var a = document.createElement("a");
      a.href = "#" + h.id; a.textContent = h.textContent;
      a.className = h.tagName === "H3" ? "lvl-3" : "lvl-2";
      a.addEventListener("click", function (e) {
        e.preventDefault();
        var top = h.getBoundingClientRect().top + window.scrollY - 84;
        window.scrollTo({ top: top, behavior: reduce ? "auto" : "smooth" });
        history.replaceState(null, "", "#" + h.id);
      });
      li.appendChild(a); ul.appendChild(li);
    });
    if (!reduce && "IntersectionObserver" in window) {
      var links = {};
      [].forEach.call(ul.querySelectorAll("a"), function (a) { links[a.getAttribute("href").slice(1)] = a; });
      var spy = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) {
          if (!en.isIntersecting) return;
          [].forEach.call(ul.querySelectorAll("a.active"), function (a) { a.classList.remove("active"); });
          var a = links[en.target.id]; if (a) a.classList.add("active");
        });
      }, { rootMargin: "-80px 0px -70% 0px", threshold: 0 });
      heads.forEach(function (h) { spy.observe(h); });
    }
  } else if (tocWrap) {
    tocWrap.style.display = "none";
  }
})();
